import { Box, Flex, Stack, Text } from '@chakra-ui/react';
import { Grid, TextLink } from '@time-line/components/common';
import type { NavGroup } from '@time-line/components/types';
import { Fragment } from 'react';
import { getTrackingId } from 'utils/getTrackingId';

import { PAYMENT_PROVIDERS } from './constants';

type MetaProps = {
  legal: NavGroup;
};

export const Meta = ({ legal }: MetaProps) => {
  const year = new Date().getFullYear();

  return (
    <Grid.Inner gridRowGap="sm">
      <Box gridColumn={{ base: 'span 12', lg: 'span 6' }}>
        <Flex align="center" direction="row">
          <Text as="span" size="detail" color="blackAlpha.700" mr="sm">
            &copy; {year}
          </Text>
          <Stack
            align="center"
            direction="row"
            spacing={{ base: 'xs', lg: 'sm' }}
          >
            {legal.subNav.items.map((legalLink, k) => (
              <TextLink
                key={k}
                href={legalLink.href}
                id={getTrackingId(legalLink.name, { parent: 'footer' })}
                textProps={{ size: 'detail', color: 'blackAlpha.700' }}
                variant="underlineOnHover"
              >
                {legalLink.label}
              </TextLink>
            ))}
          </Stack>
        </Flex>
      </Box>
      <Stack
        gridColumn={{ base: 'span 12', lg: 'span 6' }}
        direction="row"
        gap="3xs"
        justifyContent={{ lg: 'flex-end' }}
      >
        {PAYMENT_PROVIDERS.map((pp, j) => (
          <Fragment key={j}>{pp.icon}</Fragment>
        ))}
      </Stack>
    </Grid.Inner>
  );
};
